import { useId, type ReactNode } from 'react';
import { sentenceCase } from 'change-case';
import cn from 'mxcn';
import { Label } from './Label';
import { Slot, SlotProps } from '@radix-ui/react-slot';
import { useFieldErrors } from './Form';

const FormControlSlot = Slot as unknown as React.ForwardRefExoticComponent<
  SlotProps &
    React.RefAttributes<HTMLElement> & { name?: string; placeholder?: string }
>;

export default function Field(
  props: {
    className?: string;
    children: ReactNode;
    layout?: 'horizontal' | 'vertical';
  } & ({ name: string } | { name?: string; label: ReactNode })
) {
  const id = useId();
  const label = 'label' in props ? props.label : sentenceCase(props.name);
  const layout = props.layout ?? 'vertical';

  return (
    <>
      <div
        className={cn(
          props.className,
          layout === 'vertical'
            ? 'stack-1'
            : 'row-4 items-center justify-between',
          'font-sans'
        )}
      >
        <Label
          htmlFor={id}
          className={cn(
            'text-contrast-600 font-medium text-sm',
            layout === 'horizontal' && 'w-2/5'
          )}
        >
          {label}
        </Label>
        <FormControlSlot
          id={id}
          name={props.name}
          placeholder={
            typeof label === 'string'
              ? label
              : 'name' in props && props.name
                ? sentenceCase(props.name)
                : ''
          }
        >
          {props.children}
        </FormControlSlot>
      </div>
    </>
  );
}
